// extracted by mini-css-extract-plugin
export default {"link":"_7311f43","wrapper":"_ce7f5b50","image":"_f1af7564","isFullBleed":"_dee1ed00","imageCopy":"_14b4eba1"};